

// @mui material components
import Link from "@mui/material/Link";

// Template Dashboard 2 MUI components
import TemplateButton from "components/TemplateButton";
import TemplateBox from "components/TemplateBox";
import TemplateTypography from "components/TemplateTypography";

// Template Dashboard 2 MUI context
import { useTemplateController } from "context";

// Images
import icon from "assets/images/illustrations/icon-documentation.svg";

function SidenavFooter() {
  const [controller] = useTemplateController();
  const { miniSidenav, darkSidenav } = controller;

  return (
    <TemplateBox opacity={miniSidenav ? 0 : 1} sx={{ transition: "opacity 200ms linear" }}>
      <TemplateBox position="relative" textAlign="center">
   
      </TemplateBox>
    </TemplateBox>
  );
}

export default SidenavFooter;
